export const IMPORT_FILE_BEGIN = 'syftacp/IMPORT_FILE_BEGIN' as const
export const IMPORT_FILE_FAILED = 'syftacp/IMPORT_FILE_FAILED' as const
export const IMPORT_FILE_SUCCEEDED = 'syftacp/IMPORT_FILE_SUCCEEDED' as const
